import { US } from "constants/countryCodes";
import { Entity } from "types/Models/entity";
import { useCurrentGroup } from "./useCurrentGroup";

export const useUsEntities = (): Entity[] => {
  const { entities = [] } = useCurrentGroup();

  return entities.filter(({ country_code }) => country_code === US);
};
